import ActionTypes from "../constants/ActionTypes";

const initialState = {
  isFetching: false,
  count: 0,
  keys: [],
  data: [],
  error: null,
};

const documentsearchbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SEARCH_REQUEST:
      return { ...state, isFetching: true, error: null };
    case ActionTypes.FETCH_SEARCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        count: action.payload.count,
      };
    case ActionTypes.FETCH_SEARCH_FAILURE:
      return { ...state, isFetching: false, error: action.payload };

    case "CLEAR_DATA_FOLDER":
      return {
        ...state,
        data: [],
        count: 0,
        keys: [],
      };

    default:
      return state;
  }
};

export default documentsearchbarReducer;
